document.addEventListener("DOMContentLoaded", function() {
  new Swiper(".big_cstm_revs_v2 .swiper", {
    slidesPerView: 2,
    spaceBetween: 30,
    loop:true,
    navigation: {
      nextEl: ".big_cstm_revs_v2 .swiper-button-next",
      prevEl: ".big_cstm_revs_v2 .swiper-button-prev"
    },
    breakpoints: {
      749:{
        slidesPerView: 2,
        spaceBetween: 30,
      },
      650: { 
        slidesPerView: 2,
        spaceBetween: 20,
      },
      320: { 
        slidesPerView: 1,
        spaceBetween: 10,
      }
    }
  });
  
  new Swiper(".product__reviews--wrapper .big_cstm_revs_v3 .swiper", {
    slidesPerView: 2,
    spaceBetween: 30,
    loop:false,
    navigation: {
      nextEl: ".product__reviews--wrapper .big_cstm_revs_v3 .swiper-button-next",
      prevEl: ".product__reviews--wrapper .big_cstm_revs_v3 .swiper-button-prev"
    },
    breakpoints: {
      749:{
        slidesPerView: 1,
        spaceBetween: 30,
      },
      650: { 
        slidesPerView: 1,
        spaceBetween: 20,
      },
      320: { 
        slidesPerView: 1,
        spaceBetween: 10,
      }
    }
  });
});
